<template>
  <div>
    <CRow>
      <CCol xs="12" sm="12" md="4" lg="4" xl="3">
        <CCard>
          <CCardHeader class="d-flex justify-content-between">
            <b><i class="fas fa-calendar"></i>&nbsp;Compras</b>
          </CCardHeader>
          <CCardBody>
            <CRow>
              <CCol sm="12">
                <CSelect label="Sedes" :options="data_campus" placeholder="--Seleccione una sede --"
                  :value.sync="selectedCampus" @change="onCampusChange" />
              </CCol>
              <CCol xs="12" sm="12" md="12" lg="12" xxl="12">
                <CInput label="Desde" type="date" aria-label="shift_date" @input="onCampusChange" size="sm" id="init"
                  v-model="filter.init" />
              </CCol>
              <CCol xs="12" sm="12" md="12" lg="12" xxl="12">
                <CInput label="Hasta" type="date" aria-label="shift_date" @input="onCampusChange" id="end" size="sm"
                  v-model="filter.end" />
              </CCol>
              <CCol xs="12" sm="12" md="12" lg="12" xxl="12">
                <CInput label="Total de Compras" type="text" size="sm" v-model="totalCompras" disabled />
              </CCol>
              <CCol xs="12" sm="12" md="12" lg="12" xxl="12">
                <CInput label="Gasto Total de Compras" type="text" size="sm" v-model="sumaTotalCompras" disabled />
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
      <CCol xs="12" sm="12" md="8" lg="8" xl="9">
        <CTableWrapper :items="data" :fields="fields" hover :striped="true" :border="true" small fixed
          caption="Lista de compras" icon="fas fa-coins" @mtdBack="mtdBack" :size="'md'" :withActions="'2%'" :actions="true" :myButtons="myButtons" @mtd_detail_purchase="mtd_detail_purchase">
        </CTableWrapper>
      </CCol>
    </CRow>

  </div>
</template>

<script>
const fields = [
  { key: "index", label: "Id", _style: "width:1%" },
  { key: "campu", label: "Sede", _style: "width:10%;" },
  { key: "provider_name", label: "Proveedor", _style: "width:10%;" },
  { key: "detail_purchase", label: "Productos", _style: "width:10%;" },
  { key: "method_payment_text", label: "Método de pago", _style: "width:10%;" },
  { key: "document_type_name", label: "Tipo de documento", _style: "width:10%;" },
  { key: "document", label: "N° Documento", _style: "width:10%;" },
  { key: "total", label: "Total", _style: "width:5%;" },
  { key: "date_formatted", label: "Fecha", _style: "width:5%;" },
];

import CTableWrapper from "../../../components/shared/datatable/Table.vue";
import { mapActions } from "vuex";
import moment from "moment";

export default {
  components: {
    CTableWrapper,

  },
  data() {
    return {
      prefix: "purchases",
      fields,
      data: [],
      data_campus: [],
      totalCompras: 0,
      sumaTotalCompras: 0,
      filter: {
        init: null,
        end: null,
      },
      labelIcon: {
        labelOn: "\u2713",
        labelOff: "\u2715",
      },
      componentKey: 0,
      selectedCampus: null,
      myButtons: [
        {
          class: "btn-sm",
          color: "primary",
          tooltip: "Detalle de la compra",
          action: "mtd_detail_purchase",
          icon: "fas fa-file-pdf",
        },
      ],
    };
  },
  computed: {
    cpStatus: function () {
      if (this.companies.state == 1) return true;
      return false;
    },
  },
  created() {
    moment.locale("es");
    this.filter.end = moment().format("YYYY-MM-DD");
    this.filter.init = this.filter.end;
    this.mtd_data();
    this.getCampus();
  },
  methods: {
    ...mapActions(["get", "post"]),
    getCampus() {
      this.get({
        url:
          this.$store.getters.get__url +
          "/stock_transfer/getCampus/" +
          this.$store.getters.get_company.id,
        token: this.$store.getters.get__token,
      }).then((response) => {
        if (response.statusCode == 200) {
          this.data_campus = [
            { label: "Todos", value: null },
            ...response.data.map((element) => ({
              label: element.name,
              value: element.id,
            })),
          ];
        }
      });
    },
    onCampusChange() {
      if (this.selectedCampus === null) {
        this.mtd_data();
      } else {
        this.mtd_data(this.selectedCampus);
      }
    },
    mtd_data(campuId = null) {
      if (!this.filter.init || !this.filter.end || this.filter.init > this.filter.end) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Por favor, selecciona un rango de fechas válido.',
        });
      }
      this.post({
        url: this.$store.getters.get__url + "/" + this.prefix + "/indexPurchase",
        token: this.$store.getters.get__token,
        params: {
          init: this.filter.init,
          end: this.filter.end,
          campu_id: campuId,
          company_id: this.$store.getters.get_company.id,
        },
      })
        .then((response) => {
          this.clearData();
          this.data = response.data.data;
          this.totalCompras = this.data.length;
          this.sumaTotalCompras = this.data.reduce((sum, item) => sum + parseFloat(item.total || 0), 0).toFixed(2);
          this.data.forEach((item) => {
            item.provider_name = item.provider.name;
            item.campu = item.campu.name;
            item.date_formatted = moment(item.date).format("DD/MM/YYYY");
            if (item.method_payment && item.method_payment.name) {
              item.method_payment_text = item.method_payment.name;
            } else {
              item.method_payment_text = 'No especificado';
            }

            if (item.document_type && item.document_type.name) {
              item.document_type_name = item.document_type.name;
            } else {
              item.document_type_name = 'No especificado';
            }

            // item.detail_purchase = item.detail.map((det) =>
            //   det.product_unit.product
            //     ? det.product_unit.product.name
            //     : "Producto no encontrado"
            // )
            //   .join(", ")
            item.detail_purchase = item.detail.map((det) => {
              if (det.type === 'insumo' && det.insumo) {
                return det.insumo.name;
              }

              if (det.product_unit && det.product_unit.product) {
                return det.product_unit.product.name;
              }

              return "Producto no encontrado";
            }).join(", ");
          });
          let index = 1;
          this.data.forEach((arr) => {
            arr.index = index;
            index++
          });
        })
        .catch((errors) => {
          Swal.fire({
            title: errors,
            icon: "danger",
          });
        });
    },
    mtdBack: function () {
      this.$emit("mtdBack");
    },
    clearData() {
      this.data = [];
      this.totalCompras = 0;
      this.sumaTotalCompras = 0;
    },
    mtd_detail_purchase(item) {
      window.open(
        this.$store.getters.get__url + "/purchase/detail-purchase/" + item.id + "/" + this.$store.getters.get__user_id,
        "_blank"
      );
    },
  },

};
</script>

<style lang="scss" scoped></style>